import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import attachmentImage from "HELPDESK/CommonResources/images/attachment1.png";

import sentChatIcon from "HELPDESK/CommonResources/images/sentChatIcon.svg";

import 'HELPDESK/Components/QueryDetails/ViewRequestModal/EnhancementClientCommunication/enhancementclientcommunication.css';

import {
    faTimes,
    faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from 'react-toastify';
import HelpdeskApiCall from 'HelpdeskApiCall';
import config from 'config';
import axios from 'axios';
import { Base64 } from 'js-base64';


export class EnhancementClientCommunication extends Component {
    constructor(props) {
        super(props);
        this.state = {
            remarkCommunication: [],
            isCommunicationLoading: false,
            errorRemark: false,
            // take ref
            fileInputRef: React.createRef(),
            attachments: [],
            remark: '',

            errorRemark: '',
            serviceRequestId: this.props.currentQueryRequestId,
            comment: '',
            clientResponse: {},
            clientResponseFetching: false,
            openExecutiveResponse: false,
            viewAttachment: false,
            attachmentPath: '',
            attachmentFile: '',
            attachmentFileExtension: '',
            executiveResponseFetching: false,
            requestUpdateStatusId: null,
            requestTypeCompletionStatus: {},
            addingClientCommunication: false


        }
    }

    componentDidMount() {
        this.apiCallToPmToolGetClientServiceRequestClientCommunication();
        this.apiCallToGetEnhancementQueryStatus();
    }
    apiCallToGetEnhancementQueryStatus = async () => {
        // this.setState({
        //     enhancementQueryFetching: true,
        // })
        const requestData = {
            serviceRequestId: this.state.serviceRequestId,
            facultyId: config.faculty_id,
            iid: config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'helpDesk_getClientWiseEnhancementWorkFlowStatus',
            requestData,
            '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetEnhancementQueryStatus();
            }, 1000);
        } else {
            if (jsonResponse.success) {

                // if (jsonResponse.APIResult.status === 'success') {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({ requestTypeCompletionStatus: apiResult });


            } else {
                console.error("Something went wrong while fetching the data.");

                toast.error(jsonResponse.message)
                this.setState({ requestTypeCompletionStatus: {}, enhancementQueryFetching: false });
            }
        }
    }


    apiCallToValidateUpdateEnhancementQueryStatus = async () => {


        if (!this.state.requestUpdateStatusId && this.state.comment.trim().length == 0) {
            toast.error("Please select a Query Status or add comment ");

        } else if (this.state.requestUpdateStatusId && this.state.comment.trim().length !== 0) {
            this.apiCallToUpdateEnhancementCurrentQueryStatus();
            // 
        }
        else if (this.state.comment.trim().length !== 0) {
            this.apiCallToValidateAddCommunicationRequest();

        } else {
            toast.error("Please select a Query Status or add comment ");
        }



    }
    // UPDATE OR CLOSE  QUERY STATUS
    apiCallToUpdateEnhancementCurrentQueryStatus = async () => {
        this.setState({
            executiveResponseFetching: true,
        });

        try {
            let userId = config.faculty_id;
            let formData = new FormData();
            // Prepare data for the API request
            const requestData = {
                "iid": config.institute_id,
                "serviceRequestId": this.state.serviceRequestId,
                "comment": this.state.comment,
                "updatedBy": config.faculty_id,
                "updatingStatusId": this.state.requestUpdateStatusId,
                "srType": "enhancements"

            }


            // debugger;
            formData.append('helpDesk_updateClientWiseEnhancementRequestStatus', true);
            formData.append('data', Base64.encode(JSON.stringify(requestData)));

            let parameterData = {
                source: 'app',
                uid: userId,
                email: config.emailId,
                role: 'instructor'
            };

            formData.append('tokenInputParameter', Base64.encode(JSON.stringify(parameterData)));
            // this.state.attachments.forEach((attachment) => {
            //     // Append the actual file object
            //     formData.append('file[]', attachment.file);
            // });


            const headers = {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                "Authorization": "Basic " + config.user_token
            };

            // Send the API request
            const response = await axios.post(config.RootUrl + '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php', formData, { headers });
            // Handle the API response

            let jsonResponse = response.data;
            if (jsonResponse.success === true || jsonResponse.success === "true") {

                if (jsonResponse.status === 'success') {
                    this.apiCallToPmToolGetClientServiceRequestClientCommunication();
                    this.setState({ executiveResponseFetching: false, comment: '' });
                    toast.success(jsonResponse.message);
                    // 
                    this.props.onCloseModal();

                } else {
                    this.setState({ executiveResponseFetching: false, });
                    toast.warning(jsonResponse.message);
                }



            } else {
                toast.error("Something went wrong while Updating Service Request Status.");
                // clear all the stat
                this.setState({ executiveResponseFetching: false, });

            }
        } catch (error) {
            console.error("API Error:", error);
            if (error.response) {
                console.error("Error Response Data:", error.response.data);
                console.error("Error Response Status:", error.response.status);
                console.error("Error Response Headers:", error.response.headers);
            }
            toast.error("Something went wrong while Updating and going catch Service Request Status.");
            this.setState({ executiveResponseFetching: false });
        }
    };




    // pmTool_getClientServiceRequestInternalCommunication
    apiCallToPmToolGetClientServiceRequestClientCommunication = async () => {
        this.setState({
            clientResponseFetching: true,
        })
        const requestData = {
            serviceRequestId: this.state.serviceRequestId,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'helpDesk_getClientServiceRequestCommunication',
            requestData,
            '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToPmToolGetClientServiceRequestClientCommunication();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                // if (jsonResponse.APIResult.status === 'success') {
                let apiResult = jsonResponse.APIResult.data;


                // Update state with API data
                this.setState({ clientResponse: apiResult, clientResponseFetching: false });

                // } else {
                //   toast.error(jsonResponse.APIResult.message)
                //   alert('something went wrong')
                // }


            } else {
                toast.error(jsonResponse.APIResult.message)
                console.error("Something went wrong while fetching the data.");
                this.setState({ clientResponseFetching: false, clientResponse: {} });

            }
        }
    }
    //  Validate Add Request
    apiCallToValidateAddCommunicationRequest = () => {
        let Validate = true;
        if (this.state.comment.trim() === '') {
            toast.error("Please enter a comment.");
            Validate = false;
        }

        if (Validate) (
            this.apiCallToPmToolAddClientServiceRequestClientCommunication()
        )
    }
    // pmTool_addExecutiveInternalComment()

    apiCallToPmToolAddClientServiceRequestClientCommunication = async () => {

        try {
            let userId = config.faculty_id;
            let formData = new FormData();
            // Prepare data for the API request
            const requestData = {
                "serviceRequestId": this.state.serviceRequestId,
                "comment": this.state.comment,
                // "attachment": this.state.attachment,
                "addedBy": config.faculty_id,
                "team": "Implementation Team",
                "attachment": this.state.attachments.map(attachment => attachment.name),
            }

            // debugger;
            formData.append('helpDesk_addClientComment', true);
            formData.append('data', Base64.encode(JSON.stringify(requestData)));

            let parameterData = {
                source: 'app',
                uid: userId,
                email: config.emailId,
                role: 'instructor'
            };
            formData.append('tokenInputParameter', Base64.encode(JSON.stringify(parameterData)));
            // formData.append('remark_attachments', attachments);
            this.state.attachments.forEach((attachment) => {
                // Append the actual file object
                formData.append('file[]', attachment.file);
            });


            const headers = {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                "Authorization": "Basic " + config.user_token
            };

            // Send the API request
            const response = await axios.post(config.RootUrl + '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php', formData, { headers });
            // Handle the API response
            let jsonResponse = response.data;
            if (jsonResponse.success) {
                if (jsonResponse.status === 'success') {
                    toast.success(jsonResponse.message);
                    this.apiCallToPmToolGetClientServiceRequestClientCommunication();
                    this.setState({ addingClientCommunication: false, comment: '', attachments: [] });
                } else {

                    toast.success(jsonResponse.message);
                    this.setState({ addingClientCommunication: false });
                }


            } else {
                toast.error(jsonResponse.message);
                // clear all the state



                // Update state with API data
                // this.setState({ executiveResponse: apiResult, executiveResponseFetching: false });
                // this.apiCallToPmToolGetClientServiceRequestClientCommunication();
                this.setState({ addingClientCommunication: false, comment: '', attachments: [] });
            }
        } catch (error) {
            console.error("Something went wrong while fetching the data.");
            this.setState({ addingClientCommunication: false });
        }
    };



    // Trigger file input on button click
    handleAddAttachmentClick = () => {
        this.state.fileInputRef.current.click();
    };

    // Handle file upload
    handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        const newAttachments = files.map((file, index) => ({
            id: Date.now() + index,
            name: file.name,
            file: file, // Store the actual file object
        }));
        // setAttachments([...attachments, ...newAttachments]);
        // update attachments through class component state
        this.setState({ attachments: [...this.state.attachments, ...newAttachments] });
    };


    // REMOVE ATTACHMENT
    removeAttachment = (id) => {
        // setAttachments(attachments.filter((attachment) => attachment.id !== id));
        this.setState({ attachments: this.state.attachments.filter((attachment) => attachment.id !== id) });
    };
    //  i have attachments and remark and config.userId and task.task_id
    handleRemarkChange = (e) => {
        const remark = e.target.value;
        this.setState({ remark });

        if (remark.trim().length < 20) {
            // setErrorMark("Should be at least 20 characters");

            this.setState({ errorRemark: "Should be at least 20 characters" });
        } else {

            this.setState({ errorRemark: "" });
        }
    };


    returnViewAttachment = () => {
        let imageExtensions = ['png', 'jpg', 'jpeg', 'svg'];
        return (
            <div className={this.state.viewAttachment ? "modal fade show" : "modal fade"} id="modalContainer">

                <div className="modal-dialog modal-dialog-centered modal-xl viewAttachmentDialog">
                    <div className="modal-content viewAttachmentContent">
                        <div className="modal-header">
                            <div className="icon-container">
                                <FontAwesomeIcon icon={['fas', 'paperclip']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Attachment</h3>
                            <FontAwesomeIcon
                                icon={['fas', 'times']}
                                style={{ cursor: 'pointer' }}
                                size="lg"
                                color="#000000"
                                onClick={() => this.setState({ viewAttachment: false })} // Close the modal
                            />
                        </div>
                        <div className="modal-body viewAttachment-body">
                            {
                                imageExtensions.includes(this.state.attachmentFileExtension) ?
                                    <div>
                                        <img src={this.state.attachmentPath + '/' + this.state.attachmentFile} alt='attachmentimg' width='100%' height='100%' />
                                    </div>
                                    :
                                    <iframe src={this.state.attachmentPath + '/' + this.state.attachmentFile} alt="attachment" width='100%' height='100%' />
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    handleAttachmentClick = (attachment, filePath) => {

        this.setState({
            viewAttachment: true,
            attachmentPath: filePath,
            attachmentFile: attachment,
            attachmentFileExtension: attachment.substring(attachment.lastIndexOf('.') + 1)
        })

    };

    render() {
        return (
            <>
                <div
                    style={{
                        display: "flex",
                        height: "548.3px",
                        flexDirection: 'column',
                        maxHeight: "548.3px",
                        overflow: "scroll",
                        width: "100%",


                    }}
                >
                    {
                        this.state.clientResponseFetching ? <ButtonLoader /> : (
                            Object.values(this.state.clientResponse).length > 0 ?
                                Object.values(this.state.clientResponse).map((response) => (


                                    <div style={{ position: 'flex' }}>
                                        <div
                                            style={{
                                                width: "90%",
                                                padding: "20px 20px 10px 0px",
                                                margin: "0px 0px",



                                            }}
                                        // data-toggle="dropdown"


                                        >
                                            {/* Header Section */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    marginBottom: "10px",
                                                    width: '80%',
                                                }}
                                            >
                                                {/* Profile & Task Info */}
                                                <div
                                                    style={{ display: "flex", alignItems: "center", gap: "10px" }}
                                                >
                                                    <span
                                                        alt="Icon"
                                                        className='UserIconStyle'
                                                        style={{ display: 'flex', backgroundColor: '#DEE5ED', borderRadius: '50%', height: '40px', width: '40px', alignItems: 'center', justifyContent: 'center' }}
                                                    >
                                                        {response.addedByName
                                                            ? response.addedByName
                                                                .split(" ")
                                                                .slice(0, 2)
                                                                .map((name) => name[0])
                                                                .join("")
                                                                .toUpperCase()
                                                            : ""}
                                                    </span>
                                                    <div>
                                                        <p
                                                            style={{
                                                                margin: "0",
                                                                fontWeight: "bold",
                                                                fontSize: "14px",
                                                            }}
                                                        >
                                                            {response.addedByName}
                                                        </p>
                                                        <p
                                                            className='vm_custom_body9'
                                                            style={{
                                                                margin: "0",

                                                                color: "#6B7280",
                                                            }}
                                                        >
                                                            {/* On Boarding Team */}
                                                            {"Service Request ID :" + response.queryId}
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>

                                            {/* Main Task Section */}
                                            <div
                                                className="card"
                                                style={{
                                                    background: "#FFFFFF",

                                                    borderRadius: "5px 5px 0px 0px",
                                                    boxShadow: "5px 5px 5px rgba(0,0,0,0.1)",
                                                    padding: "10px",
                                                    marginLeft: "43px",
                                                    color: "#4B5563",
                                                    fontSize: "14px",
                                                    marginBottom: "0",


                                                }}
                                            >

                                                {/* {response.attachment && renderAttachment(remarkData.attachment)}  */}
                                                {

                                                    (response.attachment.split(',').length > 0 || response.attachment?.length) &&
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                        {
                                                            response.attachment.split(",").map((attachment, index) => {

                                                                return (
                                                                    <p className='vm_custom_body9' key={index} style={{ display: 'flex', width: 'auto', borderRadius: '50px', padding: '4px', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', backgroundColor: '#F1F1F1' }}
                                                                        onClick={() => this.handleAttachmentClick(attachment, response.attachmentPath)}>
                                                                        {attachment}
                                                                    </p>

                                                                );
                                                            })
                                                        }
                                                    </div>
                                                }

                                                {/* Render the modal conditionally */}
                                                {this.state.viewAttachment && this.returnViewAttachment()}
                                                <p className='vm_custom_body6'>{response.comment}</p>


                                            </div>

                                            {/* Footer Section */}
                                            <div
                                                className="card d-flex justify-content-between flex-row"
                                                style={{
                                                    display: "flex",
                                                    padding: "5px",
                                                    marginLeft: "43px",
                                                    justifyContent: "space-between",

                                                    marginTop: "0",
                                                    alignItems: "center",
                                                    background: "#F1F1F1",
                                                    borderRadius: "0px 0px 5px 5px",
                                                }}
                                            >
                                                <p className="vm_custom_body9" style={{ margin: "0", color: "#0465AC" }}>
                                                    {response.queryId + "  |  " + response.readableAddedOn}
                                                </p>

                                            </div>

                                        </div>




                                    </div>

                                )) : (
                                    <p style={{ margin: "10px", fontSize: "14px", color: "#6B7280" }}>No Client communication found</p>
                                )
                        )




                    }


                </div>
                {/* Footer Body */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: 'center',
                        backgroundColor: "#FDFDFD",
                        height: "120.5px",
                        width: "100%",
                        borderRadius: "0px 0px 7px 7px",
                        padding: "10px 20px",
                        boxShadow: "0 -1px 3px rgba(0,0,0,0.1)",
                        border: "1px solid #E6EBEF",
                    }}
                >
                    {/* Attachments Area */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "10px",
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                flexWrap: "wrap",
                                marginBottom: "10px",
                            }}
                        >
                            {/* Attachments List */}
                            {this.state.attachments.map((attachment) => (
                                <div
                                    key={attachment.id}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        backgroundColor: "#f3f4f6",
                                        border: "1px solid #d1d5db",
                                        padding: "5px 10px",
                                        borderRadius: "25px",
                                    }}
                                >
                                    <p className='vm_custom_body8'>{attachment.name}</p>
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        className='vm_custom_body8'
                                        onClick={() => this.removeAttachment(attachment.id)}
                                        size='sm'
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            color: "#6b7280",
                                            height: '14px',
                                            width: '14px'
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Comment Input + Attachment Button + Send */}
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', width: "100%" }}>
                        <button
                            onClick={this.handleAddAttachmentClick}
                            style={{
                                backgroundColor: "#fff",
                                border: "1px solid #d1d5db",
                                borderRadius: "5px",
                                padding: "5px 10px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            <img src={attachmentImage} alt="attachmentImage" />
                        </button>

                        <input
                            type="file"
                            multiple
                            ref={this.state.fileInputRef}
                            style={{ display: "none" }}
                            onChange={this.handleFileUpload}
                        />

                        <div style={{ position: "relative", width: "100%", minWidth: "0" }}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "5px",
                                    padding: "5px",
                                    gap: "5px",
                                    flexWrap: "wrap",      // <-- fixed here

                                }}
                            >
                                {/* Input Field */}
                                <textarea
                                    className="remark-placeholder"
                                    placeholder="Enter comment here"
                                    value={this.state.comment}
                                    onChange={(e) => this.setState({ comment: e.target.value })}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            this.apiCallToValidateUpdateEnhancementQueryStatus();
                                        }
                                    }}
                                    style={{
                                        flex: "1",
                                        minWidth: "200px",
                                        whiteSpace: "pre-wrap",
                                        wordWrap: "break-word",
                                        fontSize: "14px",
                                        outline: "none",
                                        border: "none",
                                        padding: "8px",
                                        // resize: "none",
                                        overflow: "auto",

                                        height: "40px",
                                        maxHeight: "80px",
                                    }}
                                />

                                {/* Dropdown */}
                                <div className='dropdown-chatbox' >
                                    {(this.props.adminUpdateStatus !== 'Admin Document Approval' || this.state.isCCAdminMember==="true") &&
                                        <select
                                            value={this.state.requestUpdateStatusId}
                                            onChange={(e) => this.setState({ requestUpdateStatusId: e.target.value })}
                                            style={{
                                                fontFamily: 'Poppins',
                                                border: "none",
                                                borderRadius: '4px',
                                                outline: "none",
                                                cursor: "pointer",
                                                fontSize: "13px",
                                                background: "#E7EBEF",
                                                padding: '5px 10px',
                                                width: '9.375rem'
                                            }}
                                        >
                                            <option style={{ fontSize: '13px' }} value="">Select Status</option>
                                            {Object.values(this.state.requestTypeCompletionStatus).length > 0 &&
                                                Object.values(this.state.requestTypeCompletionStatus).map((completionStatus) => (
                                                    <option style={{ fontSize: '13px' }} key={completionStatus.statusId} value={completionStatus.statusId}>
                                                        {completionStatus.statusName}
                                                    </option>
                                                ))}
                                        </select>
                                    }

                                    {/* Send Icon */}
                                    <img
                                        onClick={() => {
                                            this.apiCallToValidateUpdateEnhancementQueryStatus();
                                        }}
                                        src={sentChatIcon}
                                        alt="sentChatIcon"
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "16px",
                                            height: '16px',
                                            width: '16px',
                                            zIndex: 1,
                                        }}
                                        className={this.state.executiveResponseFetching || this.state.addingClientCommunication ? "spinner-border text-secondary" : ""}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div >

            </ >
        )
    }
}

export default EnhancementClientCommunication
